import React from "react";
import { Grid, Typography } from "@mui/material";
import { ArrayInput, SimpleFormIterator, ReferenceInput, SelectInput, required } from "react-admin";
import { settings } from "app";
import { documentRequests } from "api/documentsApi";
import { administrationRequests } from "api/administrationApi";

const Declarations = ({ isDisabled, citizenshipIds }) => {
  return (
    <>
      <Grid
        item
        xs={12}
        md={12}
      >
        <Typography color={"primary"}>Декларации</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
      >
        <ArrayInput
          source="declarationDtos"
          label=" "
          defaultValue={[{}]}
        >
          <SimpleFormIterator
            disableReordering
            disableAdd={isDisabled}
            disableRemove={isDisabled}
            sx={settings.style.iteratorWithoutGap}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={6}
              >
                <ReferenceInput
                  source="declarationId"
                  reference={documentRequests.getDeclarationsSelect()}
                >
                  <SelectInput
                    validate={required()}
                    readOnly={isDisabled}
                    label="Декларация"
                  />
                </ReferenceInput>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
              >
                <ReferenceInput
                  source="citizenship"
                  reference={administrationRequests.getCitizenshipSelect()}
                  filter={{ ids: citizenshipIds }}
                >
                  <SelectInput
                    label="Гражданство"
                    readOnly={isDisabled}
                    validate={required()}
                  />
                </ReferenceInput>
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </>
  );
};

export default Declarations;
